import { Heading } from '@hover/blueprint';
import { SimpleGrid } from '@hover/blueprint/chakra';
import React from 'react';

import { MenuHeader } from 'src/modules/designStudio/components/DesignMenu/Menu/MenuHeader';
import { PaletteCard } from 'src/modules/designStudio/components/DesignMenu/Menu/Templates/PaletteCard';
import type { TemplatePaletteConfig } from 'src/modules/designStudio/helpers/data/PaletteStyles';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const PaletteView = ({
  closeMenu,
  palettes,
  onPaletteViewBack,
  onPaletteSelected,
  selectedPaletteIndex,
}: {
  closeMenu: () => void;
  palettes: TemplatePaletteConfig[];
  onPaletteSelected: (index: number) => void;
  onPaletteViewBack: () => void;
  selectedPaletteIndex: number;
}) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  return (
    <>
      <MenuHeader
        closeMenu={closeMenu}
        headerText={t('menu.template.paletteTitle')}
        onBack={onPaletteViewBack}
      />
      <Heading as="h2" marginBottom="300" size={300}>
        {t('menu.template.paletteListHeader')}
      </Heading>
      <SimpleGrid minChildWidth={120} spacingX={5} spacingY={5}>
        {palettes.map((palette, index) => (
          <PaletteCard
            isSelected={selectedPaletteIndex === index}
            key={palette.paletteName}
            onClick={() => {
              onPaletteSelected(index);
            }}
            palette={palette}
            showName
          />
        ))}
      </SimpleGrid>
    </>
  );
};
